/**
 * Pure helpers shared by the admin and moderator command palettes.
 *
 * Lives in lib/ so the moderator bundle can use it without importing the admin palette (which pulls
 * admin API services into the bundle).
 */

// Derive a store-search key from a pasted URL: for facebook/instagram return the
// handle (or profile id), otherwise the bare hostname. Strips query params and www.
export const deriveSearchKey = (raw: string): string => {
  try {
    const u = new URL(raw);
    const host = u.hostname.replace(/^www\./, "");
    const firstSegment = u.pathname.split("/").filter(Boolean)[0];
    const isFacebook = ["facebook.com", "m.facebook.com", "web.facebook.com", "fb.com"].some(
      (h) => host === h || host.endsWith("." + h),
    );
    if (isFacebook) {
      if (u.pathname === "/profile.php") {
        const id = u.searchParams.get("id");
        if (id) return id;
      }
      return firstSegment || host;
    }
    const isInstagram = host === "instagram.com" || host.endsWith(".instagram.com");
    if (isInstagram) {
      return firstSegment || host;
    }
    return host;
  } catch {
    return raw;
  }
};

const MAX_URL_LENGTH = 2048;

// True for a pasted http(s) URL the scrape endpoint would accept (the server re-validates).
export const isHttpUrlInput = (raw: string): boolean => {
  const s = raw.trim();
  if (!s || s.length > MAX_URL_LENGTH || !/^https?:\/\//i.test(s)) return false;
  try {
    const u = new URL(s);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
};
